"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const checkbox_1 = __importDefault(require("@kyruus/checkbox"));
const phone_input_1 = __importDefault(require("@kyruus/phone-input"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const JoinWaitlist = ({ isChecked, onWaitlistStatusChange, phoneNumber, onPhoneChange, intl, errors, providerName }) => {
    const [touched, setTouched] = (0, react_1.useState)(false);
    const handleCheckboxChange = (status) => {
        onWaitlistStatusChange === null || onWaitlistStatusChange === void 0 ? void 0 : onWaitlistStatusChange(status);
        if (!status) {
            setTouched(false);
        }
    };
    const handlePhoneChange = ({ value, errors }) => {
        setTouched(true);
        onPhoneChange === null || onPhoneChange === void 0 ? void 0 : onPhoneChange(value, errors);
    };
    return (react_1.default.createElement(styles_1.StyledWaitlistSection, { "data-testid": "join-waitlist-section", "aria-labelledby": "wait-list-header" },
        react_1.default.createElement(styles_1.StyledWaitlistHeader, { id: "wait-list-header", "data-testid": "wait-list-header" }, intl.formatMessage(messages_1.default.joinWaitlistHeader)),
        react_1.default.createElement(styles_1.StyledWaitlistDescription, { "data-testid": "wait-list-description" }, intl.formatMessage(messages_1.default.joinWaitlistDescription)),
        react_1.default.createElement(checkbox_1.default, { "data-testid": "wait-list-checkbox", checked: isChecked, name: "appointmentWaitlist.optIn", label: intl.formatMessage(messages_1.default.joinWaitlistOptInLabel), onChange: handleCheckboxChange, hasError: false }),
        isChecked && (react_1.default.createElement(styles_1.StyledWaitlistPhoneNumberContainer, null,
            react_1.default.createElement(styles_1.StyledWaitlistPhoneInputContainer, { "data-testid": "phone-input-container" },
                react_1.default.createElement(styles_1.StyledWaitlistPhoneInputLabel, { htmlFor: "wait-list-phone-input" },
                    intl.formatMessage(messages_1.default.joinWaitlistPhoneLabel),
                    "\u00A0*"),
                react_1.default.createElement(phone_input_1.default, { id: "wait-list-phone-input", initialValue: phoneNumber || '', validate: touched, onChange: handlePhoneChange, placeholder: "(999) 999-9999", initialValueFormat: "national", countryFormat: "US", invalidMsg: intl.formatMessage(messages_1.default.invalidPhoneNumberValidationMessage), defaultCountry: "US", ariaDescribedBy: "wait-list-phone-input-description", ariaDescription: intl.formatMessage(messages_1.default.ariaJoinWaitlistPhoneInputDescription), isRequired: isChecked, label: intl.formatMessage(messages_1.default.joinWaitlistPhoneLabel), errors: errors })),
            react_1.default.createElement(styles_1.StyledWaitlistPhoneNumberInformation, { "data-testid": "wait-list-phone-number-info" }, intl.formatMessage(messages_1.default.phoneNumberInformationMessage, {
                providerName
            }))))));
};
exports.default = (0, intl_1.injectIntl)(JoinWaitlist);
//# sourceMappingURL=JoinWaitlist.js.map